import React from "react";

const CommonDetailsModal = ({
    isOpen,
    onClose,
    onDecline,
    onConfirm,
    data = {},
}) => {
    if (!isOpen) return null;

    const {
        userName = "Sivanantham R",
        userId = "34287610",
        userType = "Seller/Buyer",
        phoneNumber = "7095798532",

        accountHolderName = "Sivanantham R",
        accountNumber = "34287610",
        ifscCode = "1234567890",
        upiId = "34287610",

        requestedVia = "UPI",
        requestedAmount = 500,
    } = data;

    return (
        <div className="details-modal-overlay">
            <div className="details-modal">

                {/* Header */}
                <div className="modal-header">
                    <h2>Date &amp; Time</h2>

                    <button
                        type="button"
                        className="modal-close-btn"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <span></span>
                        <span></span>
                    </button>
                </div>

                {/* Profile Details */}
                <section className="modal-section">
                    <h3 className="section-title">Profile Details</h3>

                    <div className="details-card">
                        <DetailItem
                            label="User Name"
                            value={userName}
                        />

                        <DetailItem
                            label="User Id"
                            value={userId}
                        />

                        <DetailItem
                            label="User Type"
                            value={userType}
                        />

                        <DetailItem
                            label="User Ph Number"
                            value={phoneNumber}
                        />
                    </div>
                </section>

                {/* Account Details */}
                <section className="modal-section account-section">

                    <div className="account-title-row">
                        <h3 className="section-title">
                            Account Details
                        </h3>

                        <div className="requested-via">
                            <span>Requested Via :</span>
                            <strong>{requestedVia}</strong>
                        </div>
                    </div>

                    <div className="details-card account-card">
                        <DetailItem
                            label="A/C Holder Name"
                            value={accountHolderName}
                        />

                        <DetailItem
                            label="A/C Number"
                            value={accountNumber}
                        />

                        <DetailItem
                            label="IFSC Code"
                            value={ifscCode}
                        />

                        <DetailItem
                            label="UPI ID"
                            value={upiId}
                        />
                    </div>
                </section>

                {/* Requested Amount */}
                <div className="requested-amount">
                    <span>Requested Amount :</span>

                    <strong>
                        ₹{Number(requestedAmount).toLocaleString("en-IN")}
                    </strong>
                </div>

                {/* Buttons */}
                <div className="modal-actions">

                    <button
                        type="button"
                        className="modal-btn decline-btn"
                        onClick={onDecline}
                    >
                        Decline
                    </button>

                    <button
                        type="button"
                        className="modal-btn confirm-btn"
                        onClick={onConfirm}
                    >
                        Confirm
                    </button>

                </div>

            </div>
        </div>
    );
};


/* Reusable detail item */
const DetailItem = ({ label, value }) => {
    return (
        <div className="detail-item">
            <span className="detail-label">
                {label}
            </span>

            <span className="detail-value">
                {value || "-"}
            </span>
        </div>
    );
};

export default CommonDetailsModal;